import { v4 as uuidv4, v5 as uuidv5 } from "uuid";

// Define a custom namespace.  Readers, create your own using something like
// https://www.uuidgenerator.net/
const UUID_V5_NAMESPACE = "2baf2b7d-6ecf-4c3a-8ff3-4c01d1deb78f";

export type UUID = string;

export function uuid(): UUID {
  return uuidv4();
}

export function uuidFromEmail(email: string): string {
  return uuidv5(email, UUID_V5_NAMESPACE);
}
